import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="not-found-page">
      <SEO title="Page Not Found | Eventism" noindex />
      <div className="text-center max-w-md">
        <p className="text-8xl font-bold font-heading tracking-tighter text-indigo-500 mb-4">404</p>
        <h1 className="text-2xl font-bold mb-3">Page not found</h1>
        <p className="text-muted-foreground mb-2">
          We couldn't find <span className="font-mono text-sm bg-muted px-2 py-0.5 rounded">{location.pathname}</span>
        </p>
        <p className="text-sm text-muted-foreground mb-8">
          The page may have been moved or doesn't exist. Try one of these instead:
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link to="/" data-testid="404-home-link">
              <Home className="h-4 w-4 mr-2" /> Go Home
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/plan-event" data-testid="404-plan-link">
              <Search className="h-4 w-4 mr-2" /> Plan an Event
            </Link>
          </Button>
          <Button variant="ghost" onClick={() => window.history.back()} data-testid="404-back-btn">
            <ArrowLeft className="h-4 w-4 mr-2" /> Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
